// extracted by mini-css-extract-plugin
export default {"EmotionList":"EmoticonPicker_EmotionList__ghFMb"};